/**
 * affiliate-ref-storage.ts — Lưu "vé giới thiệu" trên trình duyệt (localStorage của tên miền hệ thống) sau khi khách mở /r/:mã.
 * Vé do server ký (HMAC) và kiểm lại hạn — đây chỉ là nơi giữ tạm; mọi truy cập bọc try/catch (chế độ riêng tư).
 */
import {
  makeStoredRef, parseStoredRef, REF_STORAGE_KEY, shouldReplaceRef, VISITOR_STORAGE_KEY, type AttributionModel, type StoredRef,
} from './affiliate'

export function readStoredRef(now = Date.now()): StoredRef | null {
  try {
    return parseStoredRef(localStorage.getItem(REF_STORAGE_KEY), now)
  } catch {
    return null
  }
}

/** Ghi vé theo mô hình ghi nhận; trả vé đang hiệu lực sau khi áp quy tắc. */
export function saveRefTicket(code: string, ticket: string, cookieDays: number, model: AttributionModel, now = Date.now()): StoredRef {
  const existing = readStoredRef(now)
  if (!shouldReplaceRef(existing, code, model)) return existing!
  const next = makeStoredRef(code, ticket, cookieDays, now)
  try {
    localStorage.setItem(REF_STORAGE_KEY, JSON.stringify(next))
  } catch {
    /* bỏ qua — trình duyệt chặn lưu trữ */
  }
  return next
}

export function visitorId(): string {
  try {
    const v = localStorage.getItem(VISITOR_STORAGE_KEY)
    if (v && /^[A-Za-z0-9-]{8,64}$/.test(v)) return v
    const id = typeof crypto !== 'undefined' && 'randomUUID' in crypto ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
    localStorage.setItem(VISITOR_STORAGE_KEY, id)
    return id
  } catch {
    return ''
  }
}
